<template>
  <div class="auth-wrapper empty-permissions">

    <div v-if="!isMobile" class="auth-wrapper auth-wrapper-left"></div>

        <div class="auth-wrapper-rigth">
            <div class="auth-wrapper__content">
      <div class="auth-wrapper__logo logo">
                    <figure class="figure-logo">
                        <img src="/static/logos/logo_dv7.png" alt="40%" width="80%">
                    </figure>
                </div>
      <p>You have no permissions yet. Wait for the admin to add your privileges.</p>
      <p class="mt-6 text-center">
        <a href="javascript:" @click="signout">Sign out</a>
      </p>
    </div>
        </div>
    
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "app-empty-permissions",

  methods: {
    signout() {
      return this.$store.dispatch("auth/signout");
    }
  },

  computed: {
    ...mapGetters({
      isMobile: "shared/isMobile"
    })
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/auth/empty-permissions/empty-permissions.vue?d0a7bbc2